import { styled } from '@mui/material';

export const ProductRouteExistLimitStyledContainer = styled('section')`
  padding: 30px;
  gap: 15px;
  display: flex;
  flex-flow: column;
  width: 100%;

  .action-wrapper {
    display: flex;
    gap: 24px;
  }
`;
